import React from 'react'
import styled, { keyframes } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Spinner = styled.div<{
  $size: number
  $durationMs: number
  $thickness: number
}>`
  border-radius: 50%;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};

  /* Create the semi-circular gradient using a conic-gradient */
  background: conic-gradient(
    from 180deg,
    ${palette.neutral[50]} 0deg,
    ${palette.neutral[50]} 180deg,
    #6616ee 180deg,
    #5fd3ec 270deg,
    #c0bee7 360deg
  );

  /* Use an inner circle to create a "hole" and form the border */
  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${({ $thickness }) => $thickness}px),
    #000 calc(100% - ${({ $thickness }) => $thickness}px)
  );
  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${({ $thickness }) => $thickness}px),
    #000 calc(100% - ${({ $thickness }) => $thickness}px)
  );

  animation: ${spin} ${({ $durationMs }) => $durationMs}ms linear infinite;
`

export default function GradientSpinner({
  size = 30,
  durationMs = 1000,
  thickness = 4,
}: {
  size?: number
  durationMs?: number
  thickness?: number
}): JSX.Element {
  return (
    <Spinner $size={size} $durationMs={durationMs} $thickness={thickness} />
  )
}
